module.exports = __webpack_public_path__ + "img/Rectangle 148@2x.b57d0415.png";